import React from "react";
import { Link } from "react-router-dom";

const PageHeader = ({ breadcrumb = [], title, description, actions }) => (
  <section className="flex scroll-mt-6 flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <div>
      {breadcrumb.length > 0 ? (
        <div className="flex flex-wrap items-center gap-2 text-sm text-slate-500">
          {breadcrumb.map((item, index) => (
            <React.Fragment key={`${item.label}-${index}`}>
              {item.to ? (
                <Link to={item.to} className="font-medium text-slate-500 hover:text-orange-600">
                  {item.label}
                </Link>
              ) : (
                <span className="font-medium text-slate-900">{item.label}</span>
              )}
              {index < breadcrumb.length - 1 ? <span>/</span> : null}
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-950 sm:text-3xl">
        {title}
      </h1>
      {description ? <p className="mt-2 text-sm text-slate-500">{description}</p> : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </section>
);

export default PageHeader;
